import {
  GROUP_DOWNLOAD_JOB_START,
  GROUP_DOWNLOAD_JOB_UPDATE,
  GROUP_DOWNLOAD_JOB_RESET,
  GROUP_DOWNLOAD_JOB_REHYDRATE,
  GROUP_DOWNLOAD_BUNDLE_DOWNLOADED,
} from "../actions/constants";

const initialState = {
  jobId: null,
  status: null,
  totalInvoices: 0,
  completedInvoices: 0,
  remainingInvoices: 0,
  bundleSize: 0,
  totalBundles: 0,
  completedBundles: 0,
  currentBundle: 0,
  progressPercentage: 0,
  currentStatusMessage: null,
  bundles: [],
  downloadedBundles: [],
  message: null,
};

const groupDownloadJob = (state = initialState, action) => {
  switch (action.type) {
    case GROUP_DOWNLOAD_JOB_START:
      return {
        ...initialState,
        jobId: action.payload.jobId,
        status: "processing",
        totalInvoices: action.payload.totalInvoices,
        remainingInvoices: action.payload.totalInvoices,
        bundleSize: action.payload.bundleSize,
        totalBundles: action.payload.totalBundles,
        currentBundle: action.payload.totalBundles > 0 ? 1 : 0,
      };

    case GROUP_DOWNLOAD_JOB_UPDATE: {
      const { progress, ...rest } = action.payload;
      return {
        ...state,
        ...rest,
        progressPercentage: progress ?? state.progressPercentage,
      };
    }

    case GROUP_DOWNLOAD_BUNDLE_DOWNLOADED:
      return {
        ...state,
        downloadedBundles: [...state.downloadedBundles, action.payload.bundleNumber],
      };

    case GROUP_DOWNLOAD_JOB_REHYDRATE:
      return {
        ...initialState,
        jobId: action.payload.jobId,
        status: "processing",
        downloadedBundles: action.payload.downloadedBundles || [],
      };

    case GROUP_DOWNLOAD_JOB_RESET:
      return initialState;

    default:
      return state;
  }
};

export default groupDownloadJob;
